// extracted by mini-css-extract-plugin
export default {"wrapper":"acceptance_wrapper__5Nqmu","text":"acceptance_text__552cQ"};